import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closePopup, openPopup } from "../../App/Slices/popupSlice";
import { RootState } from "../../App/store";
import ContractService from "../../Services/ContractService";
import ToastService from "../../Services/ToastService";
import Spinner from "../shared/Spinner/Spinner";
import "./Withdraw.scss";
import DataService from "../../Services/DataService";

export const Withdraw = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [withdrawAmount, setWithdrawAmount] = useState<number>(-1);
  let loadingToast: string;

  const userSelector = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  const withdraw = async () => {
    return userSelector.user.coin === "BCH" ? withdrawBCH() : withdrawAVAX();
  };

  const withdrawAVAX = async () => {
    setLoading(true);

    try {
      await ContractService.setUpContract();

      DataService.cloud_function
        .withdraw({
          amount: withdrawAmount,
        })
        .then((res: any) => {
          loadingToast = ToastService.loading(
            "Your request has been received. This process may take a few minutes."
          );
          closeModal();
          startWithdrawEventListener();
        })
        .catch((error: any) => {
          setLoading(false);
          ToastService.error(ContractService.handleErrorMessage(error));
        });
    } catch (error) {
      closeModal();
    }
  };

  const withdrawBCH = async () => {
    setLoading(true);

    try {
      DataService.cloud_function
        .withdraw({
          amount: withdrawAmount,
        })
        .then((res: any) => {
          loadingToast = ToastService.success(
            "Withdraw transaction sent and will be credited in a few moments."
          );
          closeModal();
        })
        .catch((error: any) => {
          setLoading(false);
          ToastService.error(error.message ?? error);
        });
    } catch (error) {
      closeModal();
    }
  };

  const startWithdrawEventListener = () => {
    ContractService.getSolidities().SlimeShadiesSolidity.on(
      "Withdrawn",
      (account: string, amount: any) => {
        console.log("Withdraw event: ", account, userSelector.user);

        if (account.toLowerCase() == userSelector.user.wallet) {
          ToastService.success("Withdrawn successfully completed.", {
            id: loadingToast,
          });
          ContractService.getSolidities().SlimeShadiesSolidity.removeAllListeners(
            "Withdrawn"
          );
        }
      }
    );
  };

  const openModal = () => {
    dispatch(openPopup(withdrawModal));
  };

  const closeModal = () => {
    dispatch(closePopup(0));
    setTimeout(() => {
      setWithdrawAmount(-1);
      setLoading(false);
    }, 100);
  };

  const withdrawModal = useMemo(
    () => (
      <div className="withdraw-modal">
        <div>
          <h2>Withdraw Balance </h2>
          <div className="form-field">
            <label htmlFor="amount">Withdraw amount</label>
            <input
              required
              placeholder="0"
              type="number"
              onChange={(e) => setWithdrawAmount(e.target.valueAsNumber)}
              id="amount"
            ></input>
            <span className="form-field-note">
              Maximum amount should be {Number(userSelector.user.balance?.toFixed(5))} {userSelector.user.coin}
            </span>
          </div>
        </div>
        <div className="actions">
          <div onClick={closeModal}>Cancel </div>
          <div
            className={
              loading ||
              !withdrawAmount ||
              withdrawAmount > userSelector.user.balance!
                ? "disabled"
                : ""
            }
            onClick={() => {
              withdraw();
            }}
          >
            {loading ? (
              <Spinner size={1.5} renderContent="Withdraw"></Spinner>
            ) : (
              <>
                Withdraw
                {withdrawAmount > 0 ? " " + withdrawAmount + ` ${userSelector.user.coin}` : ""}
              </>
            )}
          </div>
        </div>
      </div>
    ),
    [withdrawAmount, loading, userSelector.user]
  );

  useEffect(() => {
    if (withdrawAmount == -1) return;
    openModal();
  }, [withdrawAmount, loading]);

  return <button onClick={openModal}>Withdraw</button>;
};
